export const generateGuid = (data?: unknown): string => {
  const timestamp = Date.now();
  const random1 = Math.random().toString(36).substring(2, 15);
  const random2 = Math.random().toString(36).substring(2, 15);
  const performanceNow = typeof performance !== 'undefined' ? performance.now() : Math.random() * 1000000;
  
  const dataString = data !== undefined ? JSON.stringify(data) : '';
  const combinedString = `${timestamp}-${performanceNow}-${random1}-${random2}-${dataString}`;
  
  let hash1 = 0;
  let hash2 = 0;
  
  for (let i = 0; i < combinedString.length; i++) {
    const char = combinedString.charCodeAt(i);
    hash1 = ((hash1 << 5) - hash1) + char;
    hash1 = hash1 & hash1;
    
    hash2 = ((hash2 << 3) - hash2) + char;
    hash2 = hash2 & hash2;
  }
  
  const hash1Hex = Math.abs(hash1).toString(16).padStart(8, '0');
  const hash2Hex = Math.abs(hash2).toString(16).padStart(8, '0');
  const timestampHex = timestamp.toString(16).padStart(12, '0');
  const performanceHex = Math.floor(performanceNow).toString(16).padStart(8, '0');
  
  let dataHash = 0;
  if (dataString) {
    for (let i = 0; i < dataString.length; i++) {
      dataHash = ((dataHash << 7) - dataHash) + dataString.charCodeAt(i);
      dataHash = dataHash & dataHash;
    }
  }
  const dataHashHex = Math.abs(dataHash).toString(16).padStart(8, '0');
  
  const guid = [
    hash1Hex,
    timestampHex.substring(0, 4),
    timestampHex.substring(4, 8),
    performanceHex.substring(0, 4),
    performanceHex.substring(4, 8) + hash2Hex.substring(0, 4) + dataHashHex.substring(0, 4)
  ].join('-');
  
  return guid;
};
